// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3inEW","header":"ReportDetails_header__2AB8T","title":"ReportDetails_title__3Grd5","left":"ReportDetails_left__Yx271"};